import { useState } from 'react';

export default function useMemoryEditor(s) {
  const [editing, setEditing] = useState(null);
  const [text, setText] = useState('');
  const edit = memory => { setEditing(memory.id); setText(memory.text); };
  const remove = async memory => { if (await s.deleteMemory(memory) && editing === memory.id) { setEditing(null); setText(''); } };
  const confirm = memory => s.confirmMemory(memory);
  const save = async () => { if (await s.saveMemory(text, editing)) { setEditing(null); setText(''); } };
  return { editing, text, setText, edit, remove, confirm, save };
}
